import { AppID } from '@ikonintegration/idmclient';
//
import APIRequest from './core/Request';
// API Compoenents
import City from './operations/City';
import Course from './operations/Course';
import CourseCalendar from './operations/CourseCalendar';
import CourseTicket from './operations/CourseTicket';
import Instructor from './operations/Instructor';
import InstructorCalendar from './operations/InstructorCalendar';
import InstructorCalendarSync from './operations/InstructorCalendarSync';
import Locations from './operations/Locations';
import Region from './operations/Region';
import Session from './operations/Session';
import SessionAttendance from './operations/SessionAttendance';
import SessionCharge from './operations/SessionCharge';
import SessionEnrolment from './operations/SessionEnrolment';
import SessionFile from './operations/SessionFile';
import SessionInvitation from './operations/SessionInvitation';
import SessionResult from './operations/SessionResult';
import Template from './operations/Template';
import Venue from './operations/Venue';
import Report from './operations/Report';
//
export default class Client {
  /* config structure
    {
      port: 9090, //optional
      endpoint: SharedModules_ClassroomEndpoint,

      //Must be specified when using service routes
      apiKey: config.examProvider.key, //API token on IDM.AppID format (generate from APIKey at https://runkit.com/gwdp/idm-appid-v1)

      //Must be specified if not using 'apiKey'
      authorizationToken: '', -- optional, IDM JWT for admins, instructos and user routes -- Accepts a function to be called async and return the token

      //Required if calling on customer scope
      customerID: '',
        //Should be one or another (customer admin mode, or tenant mode (tenant admins, instructors and users))
      tenantID: ''
    }
  */
  constructor(config) {
    this.config = config;
    // api operations
    this.city = new City(this);
    this.course = new Course(this);
    this.courseCalendar = new CourseCalendar(this);
    this.courseTicket = new CourseTicket(this);
    this.instructor = new Instructor(this);
    this.instructorCalendar = new InstructorCalendar(this);
    this.instructorCalendarSync = new InstructorCalendarSync(this);
    this.locations = new Locations(this);
    this.region = new Region(this);
    this.report = new Report(this);
    this.session = new Session(this);
    this.sessionAttendance = new SessionAttendance(this);
    this.sessionCharge = new SessionCharge(this);
    this.sessionEnrolment = new SessionEnrolment(this);
    this.sessionFile = new SessionFile(this);
    this.sessionInvitation = new SessionInvitation(this);
    this.sessionResult = new SessionResult(this);
    this.template = new Template(this);
    this.venue = new Venue(this);
  }

  async newBaseRequest(method) {
    const req = new APIRequest(method);
    //Auth
    if (this.config.apiKey) {
      const token = new AppID(null, this.config.apiKey, this.config.apiKey);
      req.appendHeader('API-Key', token.getHash());
    }
    if (this.config.authorizationToken) {
      let token = this.config.authorizationToken;
      if (typeof this.config.authorizationToken === "function") token = await this.config.authorizationToken();
      req.appendHeader('Authorization', token);
    }
    if (this.config.customerID) req.appendHeader('customerID', this.config.customerID);
    if (this.config.tenantID) req.appendHeader('tenantID', this.config.tenantID);
    //
    req.baseURL = this.config.endpoint;
    if (this.config.port) req.baseURL += `:${this.config.port}`;
    //
    return req;
  }
}
